import React, { useEffect, useState } from 'react';
import { UserPlus, Users } from 'lucide-react';
import { useSearchParams } from 'react-router';
import Sidebar from '../../components/Sidebar';
import DashboardDoctorHeader from '../../components/MainHeader/DashboardDoctorHeader';
import CollaborationLists from './components/CollaborationLists';
import CollaborationWorkspace from './components/CollaborationWorkspace';
import CreateCollaborationDialog from './components/CreateCollaborationDialog';
import DoctorSearchPanel from './components/DoctorSearchPanel';
import { useCollaborations } from './hooks/useCollaborationQueries';
import './collaboration.css';

export function CollaborationPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [group, setGroup] = useState('pending');
  const [mainTab, setMainTab] = useState('collaborations');
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const collaborations = useCollaborations();
  const selectedCollaboration = searchParams.get('collaboration');

  useEffect(() => {
    if (!selectedCollaboration && collaborations.data?.pending?.length === 0) setGroup('active');
  }, [collaborations.data?.pending?.length, selectedCollaboration]);

  const toggleDoctor = (doctor) => setSelectedDoctors((current) => current.some((item) => String(item.id) === String(doctor.id))
    ? current.filter((item) => String(item.id) !== String(doctor.id))
    : [...current, doctor]);

  const handleCreated = (collaborationId) => {
    setSelectedDoctors([]);
    setDialogOpen(false);
    if (collaborationId) setSearchParams({ collaboration: collaborationId });
  };

  return (
    <div className="doctormain">
      <Sidebar />
      <div className={`rightSec${selectedCollaboration ? ' collab-right--workspace' : ''}`}>
        <DashboardDoctorHeader hideSearch />
        <main className={`mainDiv collab-page${selectedCollaboration ? ' collab-page--workspace' : ''}`}>
          {selectedCollaboration ? (
            <CollaborationWorkspace collaborationId={selectedCollaboration} onClose={() => setSearchParams({})} />
          ) : (
            <>
              <header className="collab-hero">
                <div><p className="collab-eyebrow">Care team collaboration</p><h1>Collaborations</h1><p>Coordinate care around a patient in a protected, auditable workspace.</p></div>
                {mainTab === 'find' && <button type="button" className="collab-button collab-button--primary" onClick={() => setDialogOpen(true)} disabled={selectedDoctors.length === 0}><UserPlus size={17} /> Start collaboration {selectedDoctors.length > 0 && `(${selectedDoctors.length})`}</button>}
              </header>
              <div className="collab-main-tabs" role="tablist" aria-label="Collaboration sections">
                <button type="button" role="tab" aria-selected={mainTab === 'find'} className={mainTab === 'find' ? 'is-active' : ''} onClick={() => setMainTab('find')}>Find doctors</button>
                <button type="button" role="tab" aria-selected={mainTab === 'collaborations'} className={mainTab === 'collaborations' ? 'is-active' : ''} onClick={() => setMainTab('collaborations')}>My collaborations {collaborations.data?.pending?.length > 0 && <span>{collaborations.data.pending.length}</span>}</button>
              </div>
              <div className="collab-layout collab-layout--single">
                {mainTab === 'find' ? <DoctorSearchPanel selectedIds={selectedDoctors.map((doctor) => String(doctor.id))} onToggle={toggleDoctor} /> : <div className="collab-overview">
                  <div className="collab-section-title"><div><p className="collab-eyebrow">Your workspaces</p><h2><Users size={20} /> Patient teams</h2></div></div>
                  {collaborations.isLoading ? <div className="collab-state">Loading collaborations…</div> : collaborations.isError ? <div className="collab-state collab-state--error">Unable to load collaborations.</div> : <CollaborationLists data={collaborations.data} activeGroup={group} onGroupChange={setGroup} onOpen={(id) => setSearchParams({ collaboration: id })} />}
                </div>}
              </div>
              <CreateCollaborationDialog open={dialogOpen} doctors={selectedDoctors} onClose={() => setDialogOpen(false)} onCreated={handleCreated} />
            </>
          )}
        </main>
      </div>
    </div>
  );
}

export default CollaborationPage;
